<template>
    <div class="loading-wrap" ref="loadingWrap">
        <v-spinner />
    </div>
</template>

<script>
import Vue from "vue";
import { mapMutations, mapState } from "vuex";
import { getGlobalSchema, getSchema } from "@/api/configs";

export default {
    name: "loading",
    created() {
        this.load_data();
    },
    computed: {
        ...mapState("global", ["currentLang"]),
    },
    methods: {
        ...mapMutations("global", [
            "updateSchema",
            "updatePreloading",
            "updatePreloadingDone",
        ]),
        async load_data() {
            let globalData = await getGlobalSchema(
                "mgmedia/schema/global.json",
            );
            //  获取浏览器语言
            let browserLanguage =
                window.navigator.userLanguage || window.navigator.language;
            let langDate = globalData.data.item.translate.data;

            // this.updateSchema({
            //     name: globalData.data.name,
            //     value: globalData.data
            // });

            // 判断浏览器语言，选择相应的语言
            if (browserLanguage) {
                Vue.prototype.$loginTL = browserLanguage.includes("zh")
                    ? langDate.zh_cn
                    : langDate.en;

                document.body.classList.add(browserLanguage);
                !browserLanguage.includes("zh") &&
                    (document.title = langDate.en.websitName);
            } else {
                Vue.prototype.$loginTL = langDate.en;
            }
            this.updatePreloading();
            this.updatePreloadingDone();
        },
    },
};
</script>

<style lang="scss">
.loading-wrap {
    width: 100%;
    height: 100%;

    .v-spinner {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        margin: auto;
        width: 50px;
        height: 50px;
    }
}
</style>
